import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ScrollToTop from "../components/ScrollToTop.jsx";

function Inicio() {
  return (
    <div className="main-container">
      <Helmet>
        <title>La CLO Brand - Tienda de Moda y Accesorios Únicos</title>
        <meta
          name="description"
          content="Descubre La CLO Brand, tu tienda online de moda, accesorios únicos y prendedores artesanales. Diseños exclusivos que realzan tu estilo personal."
        />
        <meta
          name="keywords"
          content="moda, accesorios, prendedores, brooches, joyería artesanal, diseño único, La CLO Brand, fashion, complementos"
        />
        <meta
          property="og:title"
          content="La CLO Brand - Moda y Accesorios Únicos"
        />
        <meta
          property="og:description"
          content="Explora nuestra colección exclusiva de accesorios y prendedores artesanales. Diseños que reflejan tu personalidad."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.laclobrand.com.ar" />
        <meta
          property="og:image"
          content="https://www.laclobrand.com.ar/vestidonoche.avif"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="La CLO Brand - Moda y Accesorios" />
        <meta
          name="twitter:description"
          content="Descubre accesorios únicos y prendedores artesanales que realzan tu estilo."
        />
        <link rel="canonical" href="https://www.laclobrand.com.ar" />
      </Helmet>

      {/* Video pegado al nav sin márgenes */}
      <section className="video-hero">
        <div className="video-container">
          <video
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
            poster="/images/video-poster.jpg"
          >
            <source
              src="/brocheclobrand.mp4"
              type="video/mp4"
              aria-multilinear="true"
            />
            {/* Mensaje de fallback si el video no se puede cargar */}
            <p>Your browser does not support the video tag.</p>
          </video>

          {/* Overlay con contenido */}
          <div className="video-overlay">
            <div className="hero-content"></div>
          </div>
        </div>
      </section>

      <section className="inicio-hero">
        <h1>La CLO Brand</h1>
        <p>
          Descubre el poder de lo místico con nuestra colección exclusiva de
          productos mágicos. Donde la energía espiritual se encuentra con el
          bienestar.
        </p>

        <Link
          to="/Productos"
          style={{ textDecoration: "none", display: "inline-block" }}
        >
          <button
            className="btn-mystical"
            style={{
              position: "relative",
              zIndex: 10,
            }}
          >
            🌟 Explorar Productos Místicos
          </button>
        </Link>
      </section>

      <section className="featured-content">
        <div
          className="mystical-card"
          style={{
            padding: "2rem",
            borderRadius: "15px",
            margin: "2rem 0",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontFamily: "var(--font-heading)",
              fontSize: "2rem",
              color: "var(--accent-teal)",
              marginBottom: "1rem",
              fontWeight: "600",
            }}
          >
            🔮 Productos Espirituales
          </h2>
          <p
            style={{
              fontSize: "0.9rem",
              color: "var(--slate-200)",
              lineHeight: "1.8",
              fontWeight: "400",
            }}
          >
            Sumérgete en un mundo de energías positivas donde cada producto está
            cuidadosamente seleccionado y elaborado con amor. Desde prendas
            elaboradas energéticamente con telas o tejidos nobles, objetos
            pintados a mano con motivos espirituales hasta elegantes accesorios
            que protegen tu aura. Cada artículo en nuestra tienda está diseñado
            para elevar tu vibración y armonizar tu entorno.
          </p>
        </div>

        {/* Categorías Destacadas */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "1.5rem",
            marginTop: "2rem",
          }}
        >
          <div
            className="mystical-card"
            style={{
              padding: "1.5rem",
              borderRadius: "12px",
              textAlign: "center",
              transition: "all 0.3s ease",
            }}
          >
            <div style={{ fontSize: "3rem", marginBottom: "0.5rem" }}>👗</div>
            <h3
              style={{
                color: "var(--accent-purple)",
                marginBottom: "0.5rem",
                fontFamily: "var(--font-heading)",
              }}
            >
              Ropa
            </h3>
            <p style={{ color: "var(--slate-300)", fontSize: "0.95rem" }}>
              Prendas con símbolos espirituales, cargadas de buena vibra.
            </p>
          </div>

          <div
            className="mystical-card"
            style={{
              padding: "1.5rem",
              borderRadius: "12px",
              textAlign: "center",
              transition: "all 0.3s ease",
            }}
          >
            <div style={{ fontSize: "3rem", marginBottom: "0.5rem" }}>🧿</div>
            <h3
              style={{
                color: "var(--accent-purple)",
                marginBottom: "0.5rem",
                fontFamily: "var(--font-heading)",
              }}
            >
              Accesorios
            </h3>
            <p style={{ color: "var(--slate-300)", fontSize: "0.95rem" }}>
              Protección y energía positiva
            </p>
          </div>

          <div
            className="mystical-card"
            style={{
              padding: "1.5rem",
              borderRadius: "12px",
              textAlign: "center",
              transition: "all 0.3s ease",
            }}
          >
            <div style={{ fontSize: "3rem", marginBottom: "0.5rem" }}>🔮</div>
            <h3
              style={{
                color: "var(--accent-purple)",
                marginBottom: "0.5rem",
                fontFamily: "var(--font-heading)",
              }}
            >
              Tarot
            </h3>
            <p style={{ color: "var(--slate-300)", fontSize: "0.95rem" }}>
              Mazos completos y guías para tus lecturas
            </p>
          </div>

          <div
            className="mystical-card"
            style={{
              padding: "1.5rem",
              borderRadius: "12px",
              textAlign: "center",
              transition: "all 0.3s ease",
            }}
          >
            <div style={{ fontSize: "3rem", marginBottom: "0.5rem" }}>💎</div>
            <h3
              style={{
                color: "var(--accent-purple)",
                marginBottom: "0.5rem",
                fontFamily: "var(--font-heading)",
              }}
            >
              Cristales
            </h3>
            <p style={{ color: "var(--slate-300)", fontSize: "0.95rem" }}>
              Gemas naturales con energía positiva
            </p>
          </div>
        </div>
      </section>
      <ScrollToTop />
    </div>
  );
}

export default Inicio;
